import { useEffect, useState } from 'react';

import { useFeatureFlag } from 'shared/hooks';
import { FeatureFlags } from 'featureFlags/constants';
import { bugsnag } from 'shared/utils/services/bugsnag';

declare global {
  interface Window {
    OneTrust: any;
  }
}

const hideBuggyOneTrustOverlayHack = () => {
  setTimeout(() => {
    const overlay = window.document.body.querySelector('.onetrust-pc-dark-filter');

    if (overlay) {
      const forceHideOverlay = () => {
        if (overlay) {
          overlay.setAttribute('style', `${overlay.getAttribute('style')} display: none;`);
          overlay.removeEventListener('click', forceHideOverlay);
          window?.OneTrust?.Close?.();
        }
      };

      overlay.addEventListener('click', forceHideOverlay);
    }
  }, 500);
};

/**
 * This custom link is necessary due to how One Trust injects their link onto our
 * site and how nextjs renders our footer. This implementation was taken from FC
 * https://github.com/goatapp/flightclub.com/blob/main/src/layout/footer/OneTrustLink.tsx
 */
export const OneTrustLink = () => {
  const shouldForceHideOneTrust = useFeatureFlag(FeatureFlags.TEMP_WEB_FORCE_HIDE_ONE_TRUST);
  const [cookieLinkText, setCookieLinkText] = useState('Cookies Settings');

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (window.OneTrust) {
        try {
          const cookieSettingButtonText = window.OneTrust.GetDomainData().CookieSettingButtonText;

          setCookieLinkText(cookieSettingButtonText);
        } catch (error) {
          bugsnag(error, { context: 'OneTrustLink' });
        }
      }
    }, 1000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <button
      type="button"
      id="one-trust-footer-link"
      data-qa="footer_one_trust_link"
      onClick={() => {
        window.OneTrust?.ToggleInfoDisplay?.();

        if (shouldForceHideOneTrust) {
          hideBuggyOneTrustOverlayHack();
        }
      }}
    >
      {cookieLinkText}
    </button>
  );
};
